import * as styles from './TableRow.module.css'

import React from 'react'
import classNames from 'classnames'

import CardHover from 'components/cards/CardHover'

import { Card } from './data'

import HistogramRow from './HistogramRow'

interface Props {
  card: Card
  useStandardDeviations: boolean
}

function label(
  value: number,
  set: string,
  group: string,
  useStandardDeviations: boolean,
) {
  if (useStandardDeviations) {
    return `${Math.abs(value).toFixed(1)} standard deviations ${
      value > 0 ? 'greater' : 'less'
    } than ${set.toUpperCase()}'s average cube retention`
  }
  return `${(Math.abs(value) * 100).toFixed(1)}% ${
    value < 0 ? 'less' : 'more'
  } play on ${group} than in our survey`
}

const TableRow: React.FC<Props> = (props) => {
  const { card, useStandardDeviations } = props

  return (
    <tr className={styles.container}>
      <td>
        <HistogramRow
          values={[
            {
              value: useStandardDeviations
                ? card.distanceFromSetMean
                : card.changeRelativeToRespondents,
              label: label(
                useStandardDeviations
                  ? card.distanceFromSetMean
                  : card.changeRelativeToRespondents,
                card.set,
                'surveyed',
                useStandardDeviations,
              ),
            },
            {
              value: useStandardDeviations
                ? card.changeRelativeToAllCubeCobra * 10
                : card.changeRelativeToAllCubeCobra,
              label: label(
                card.changeRelativeToAllCubeCobra,
                card.set,
                'Cube Cobra',
                false,
              ),
            },
          ]}
          min={useStandardDeviations ? -7.5 : -1}
          max={useStandardDeviations ? 11 : 0.5}
        />
      </td>
      <td className={styles.cell}>
        <CardHover card={card.name} set={card.set}>
          {card.name}{' '}
          <span className={styles.set}>- {card.set.toUpperCase()}</span>
        </CardHover>
      </td>
      <td className={classNames(styles.cell, styles.center)}>
        {card.averageRating.toFixed(1)}
      </td>
      <td className={classNames(styles.cell, styles.center)}>
        {(card.testerFraction * 100).toFixed(1)}%
      </td>
      <td className={classNames(styles.cell, styles.center)}>
        <a
          href={`https://cubecobra.com/tool/card/${card.name}`}
          title={`View ${card.name} on Cube Cobra`}
        >
          {card.ccCubes}
        </a>
      </td>
    </tr>
  )
}

export default React.memo(TableRow)
